import React from "react";

import { RobotoButton } from "@/shared/components";
import { RobotoLLMContext } from "@/shared/domain/chat/ChatRecord.ts";

import styles from "./NewChatExamples.module.css";

interface NewChatExampleProps {
  question: string;
  onExampleClick: (question: string) => void;
}

interface NewChatExamplesProps {
  onExampleClick: (question: string) => void;
  context: RobotoLLMContext;
}

const NewChatExample = ({ onExampleClick, question }: NewChatExampleProps) => {
  return (
    <RobotoButton
      variant="outlined"
      size="small"
      onClick={() => onExampleClick(question)}
      className={styles.exampleButton}
      eventName={"ExampleChatMessageClicked"}
    >
      {question}
    </RobotoButton>
  );
};

const NewChatExamples = ({ onExampleClick, context }: NewChatExamplesProps) => {
  const questions = React.useMemo(() => {
    if (context.dataset_ids.length > 0) {
      return [
        "Briefly summarize this dataset",
        "Link me to interesting visualizations",
        "What topics are available?",
        "Are there events in this dataset?",
      ];
    }

    if (context.file_ids.length > 0) {
      return [
        "Briefly summarize this file",
        "What topics are available?",
        "Open a plot for me",
      ];
    }

    return [
      "What datasets were created today?",
      "What are some tags I can search for?",
    ];
  }, [context]);

  return (
    <div className={styles.mainContainer}>
      {questions.map((question, index) => (
        <NewChatExample
          key={index}
          onExampleClick={onExampleClick}
          question={question}
        />
      ))}
    </div>
  );
};

export { NewChatExamples };
